import React from "react";
import { Link } from "react-router-dom";
import "../../style/hub.css";
import { BadukIcon, EternalReturnIcon } from "./icons";

export default function Hub() {
  return (
    <div className="hub-page">
      <div className="hub-buttons">
        <Link to="/bser-top-ranker" className="hub-square-button hub-square-button--er">
          <EternalReturnIcon />
          <span className="hub-label">이리</span>
        </Link>
        {/* /go는 choco-proxy가 다른 컨테이너로 라우팅하는 경로라 풀 페이지 이동 필요 */}
        <a href="/go" className="hub-square-button hub-square-button--baduk">
          <BadukIcon />
          <span className="hub-label">바둑</span>
        </a>
      </div>
    </div>
  );
}
